import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentEPUAPSubmitRoute: RouteConfig = {
  path: 'documentEPUAPSubmit',
  name: 'documentEPUAPSubmit',
  component: () =>
    import(/* webpackChunkName: "DocumentEPUAPSubmit" */ '@/views/mainRoute/document/epuap/DocumentEPUAPSubmit.vue'),
  meta: { breadcrumb: { title: 'Podpisywanie dokumentu' } },
  beforeEnter: (to, from, next) =>
    store
      .dispatch('document/validateDuplicatedData', { id: tryParseInt(to.params.documentId) })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych dokumentu.' }))
};
